import * as React from 'react';
import PropTypes from 'prop-types';

const Persons = ({ color = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={27} height={25} fill="none" {...props}>
    <path
      stroke={color}
      strokeLinejoin="round"
      d="M8.286 14.715v2.524l-4.504 1.635C2.702 19.264 2 20.299 2 21.456v1.725h17.143v-1.725c0-1.157-.704-2.19-1.782-2.582l-4.503-1.634v-2.67"
    />
    <path
      stroke={color}
      strokeLinejoin="round"
      d="M14.97 9.928c0 3.03-2.02 5.486-4.511 5.486-2.493 0-4.512-2.456-4.512-5.486 0-3.027 2.02-5.481 4.512-5.481 2.49 0 4.51 2.454 4.51 5.481Z"
      clipRule="evenodd"
    />
    <path
      stroke={color}
      strokeLinejoin="round"
      d="M14.934 9.435c-.15.02-.275.008-.427.038-1.538.3-2.524-.265-3.37-1.764-.508.985-2.093 1.764-3.397 1.764-.641 0-1.194-.133-1.746-.427"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M22.035 23.18H26v-1.723c0-1.158-.703-2.191-1.782-2.583l-4.503-1.634v-2.67"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17.316 4.447c2.491 0 4.51 2.454 4.51 5.482 0 3.03-2.02 5.485-4.51 5.485"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21.791 9.435c-.15.02-.275.008-.427.038-1.538.3-2.524-.265-3.37-1.764"
    />
  </svg>
);

Persons.propTypes = {
  color: PropTypes.string
};

export default Persons;
